export default __webpack_public_path__ + "static/media/Copy of The Kruks Photography-899_tn.ca83e6d6.jpg";